import Vue from 'vue';
import Vuex from 'vuex';
import gtag from '@/tracking/gtag';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: {
    error: null,
    processing: false,
    questions: [],
    answeredQuestions: [],
    currentQuestionId: null,
    previousQuestionId: null,
  },

  getters: {
    error: (state) => state.error,
    processing: (state) => state.processing,
    questions: (state) => state.questions,
    answeredQuestions: (state) => state.answeredQuestions,
    currentQuestion: (state) => state.questions.find((question) => (
      question.id === state.currentQuestionId
    )),
    previousQuestion: (state) => state.questions.find((question) => (
      question.id === state.previousQuestionId
    )),
    currentQuestionId: (state) => state.currentQuestionId,
    previousQuestionId: (state) => state.previousQuestionId,
  },

  actions: {
    onAnswer({ getters, commit, dispatch }, [answerId = null, openAnswer = '']) {
      commit('addAnsweredQuestion', [answerId, openAnswer]);

      dispatch('shootEvent', [answerId, openAnswer]);

      commit('updateCurrentQuestionId', getters.currentQuestion);
      // commit('updatePreviousQuestionId', getters.currentQuestion);
    },

    shootEvent({ getters }, [answerId = null, openAnswer = '']) {
      const { question, number } = getters.currentQuestion;
      let answer = openAnswer;

      if (getters.currentQuestion.answers.length) {
        answer = getters.currentQuestion.answers.find((a) => a.id === answerId).answer;
      }

      gtag.event(
        'Slaapwijzer',
        'Vraag beantwoord',
        `Vraag ${number}: ${question} Antwoord: ${answer}`,
      );
    },

    submitForm({ state, commit }, fields) {
      commit('setProcessing', true);

      $.post(window.app.api.survey, {
        answers: state.answeredQuestions,
        form: fields,
      }).then(() => {
        $('#thanksModal').modal('show');

        gtag.event(
          'Slaapwijzer',
          'E-mailadres ingevuld',
        );
      }).catch(() => {
        commit('setError', 'Er is iets mis gegaan, probeer het later nog een keer.');
        commit('setProcessing', false);
      });
    },
  },

  mutations: {
    hydrate(state, obj) {
      state.questions = JSON.parse(obj.questions);
      state.currentQuestionId = JSON.parse(obj.questions)[0].id;
    },

    addAnsweredQuestion(state, [answerId, answer]) {
      state.answeredQuestions.push({
        question_id: state.currentQuestionId,
        answer_id: answerId,
        answer,
      });
    },

    updateCurrentQuestionId(state, currentQuestion) {
      const currentQuestionIndex = state.questions.indexOf(currentQuestion);
      const nextQuestionIndex = (currentQuestionIndex + 1) % state.questions.length;

      state.currentQuestionId = state.questions[nextQuestionIndex].id;
    },

    updatePreviousQuestionId(state, currentQuestion) {
      const currentQuestionIndex = state.questions.indexOf(currentQuestion);
      const previousQuestionIndex = (currentQuestionIndex - 1) % state.questions.length;

      state.previousQuestionId = state.questions[previousQuestionIndex].id;
    },

    setError(state, error) {
      state.error = error;
    },

    setProcessing(state, isProcessing) {
      state.processing = isProcessing;
    },
  },
});
